import React from 'react';

const PricingOptionsButtons = (props) => {
    return (
        props.pricingOptions.map((price, i) => {
            price.value = price.value || price.visibility;
            if (price.value !== 'hidden') {
                if (!props.user.role) {
                    if(price.value === 'all') {
                        return (
                            <button
                                className="showtix-button showtix-background__primary-1 is-full-width"
                                key={i}
                                onClick={props.handleChange}
                                value={price.id}
                            >
                                {price.desc} - {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(price.amount)}
                            </button>
                        )
                    }
                } else {
                    return (
                        <button
                                className="showtix-button showtix-background__primary-1 is-full-width"
                                key={i}
                                onClick={props.handleChange}
                                value={price.id}
                            >
                            {price.desc} - {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(price.amount)} 
                            {price.value === 'box-office' && ' (Box Office Only Price)'}
                        </button>
                    )
                }
            }
        })
    )
}

export default PricingOptionsButtons;


// WEBPACK FOOTER //
// ./src/components/Common/PricingOptionsButtons/PricingOptionsButtons.js